import { PageHero } from "./Services";
import { MapPin, Route } from "lucide-react";

const PRIMARY = [
  { name: "Chula Vista", desc: "HQ zone — Eastlake, Otay Ranch, Millenia and surrounding neighborhoods." },
  { name: "Eastlake", desc: "Full same-day coverage across the master-planned community." },
  { name: "Downtown San Diego", desc: "Gaslamp, East Village, Little Italy, Marina, and Cortez Hill." },
  { name: "Mission Valley", desc: "Central San Diego routes with easy freeway access." },
  { name: "La Jolla", desc: "Coastal residential and estate service." },
  { name: "El Cajon", desc: "East County coverage — El Cajon and neighboring towns." },
  { name: "Poway", desc: "North inland San Diego, including nearby communities." },
  { name: "Del Mar", desc: "North coastal precision — Del Mar, Solana Beach, Rancho Santa Fe." },
  { name: "Oceanside", desc: "North County ops — Oceanside, Carlsbad, Vista, San Marcos." },
  { name: "Carlsbad", desc: "Full residential and delivery coverage." },
  { name: "Vista", desc: "North County residential and light commercial." },
  { name: "San Marcos", desc: "Inland North County — same-day availability." },
  { name: "Encinitas", desc: "North coastal — Encinitas, Cardiff, Leucadia." },
];

const CORRIDORS = [
  { name: "Temecula", desc: "Regular runs into Temecula Valley wine country and surrounding areas." },
  { name: "Los Angeles", desc: "Scheduled long-distance moves between San Diego County and greater LA." },
  { name: "Las Vegas", desc: "Weekly SD ⇄ Vegas corridor for relocations and long-hauls. Locked flat rates." },
  { name: "Santa Barbara", desc: "Long-distance corridor available on scheduled windows." },
];

const Card = ({ name, desc, type }) => (
  <div data-testid={`area-card-${name.toLowerCase().replace(/ /g, "-")}`} className="rounded-xl border bg-card p-6 card-lift">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        {type === "PRIMARY ZONE" ? <MapPin className="w-5 h-5 text-[var(--cc-accent)]" /> : <Route className="w-5 h-5 text-[var(--cc-accent)]" />}
        <h3 className="font-heading font-bold text-xl">{name}</h3>
      </div>
      <span className="overline-cc">{type}</span>
    </div>
    <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{desc}</p>
  </div>
);

export default function ServiceAreas() {
  return (
    <div>
      <PageHero overline="Service Areas" title="Regional coverage. Corridor precision."
        sub="Primary operations across San Diego County, with dedicated long-distance corridors to LA, Las Vegas, and beyond." />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20 space-y-16">
        <div>
          <p className="overline-cc mb-4">Primary Zones · Same-day availability</p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {PRIMARY.map((a) => <Card key={a.name} {...a} type="PRIMARY ZONE" />)}
          </div>
        </div>
        <div>
          <p className="overline-cc mb-4">Long-Distance Corridors · Scheduled runs</p>
          <div className="grid md:grid-cols-2 gap-5">
            {CORRIDORS.map((a) => <Card key={a.name} {...a} type="LONG-DISTANCE" />)}
          </div>
        </div>
        <div className="rounded-xl border border-dashed p-8 text-center bg-secondary/40">
          <p className="text-sm text-muted-foreground">Outside these zones? <a href="/contact" className="text-[var(--cc-accent)] font-semibold">Contact us</a> — we regularly run custom corridors on request.</p>
        </div>
      </section>
    </div>
  );
}
